<template>
    <section class="section-instagram bg-black-700">
        <instagram-cell
            v-for="(post, index) in sectionInstagram.latestInstagramPosts"
            :key="post.id"
            :index="index"
            :post="post" />

        <!--Section CTA button-->
        <div class="cell-14 see-more cursor-pointer flex justify-center bg-gray-900">
            <tis-button
                :url="externalLinks.instagram"
                target="_blank"
                :title="sectionInstagram.seeMoreLabel"
                class="uppercase text-gold-500 flex tablet:flex-col justify-center items-center align-center hover:scale-110 transition-all">
                <tis-logo
                    classes="logo p-2 mx-4 border-gold-500 border w-18 h-18 tablet:mb-4"
                    width="auto"
                    height="auto"
                />
                <div class="w-32 flex mobile:flex-col text-sm">
                    {{ sectionInstagram.seeMoreLabel }}
                    <svg-icon
                        icon="arrowHorizontal"
                        class="w-8 h-8" />
                </div>
            </tis-button>
        </div>
    </section>
</template>

<script>
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';
import InstagramCell from '@web/components/InstagramCell';
import TisLogo from '@whisper/components/TisLogo';

export default {
  name: 'SectionInstagram',
  components: {
    TisLogo, InstagramCell, SvgIcon, TisButton,
  },
  props: ['sectionInstagram', 'externalLinks'],
};
</script>

<style lang="scss" scoped>
    section.section-instagram {
        @screen mobile {
            min-height: unset;
        }

        @screen tabletLandscape {
            min-height: unset;
        }

        @screen desktop {
            min-height: unset;
        }

        @screen hd {
            min-height: unset;
        }
    }

    .section-instagram {
        min-height: 0;
    }

    .cell-1 img {
        width: 100%;
    }

    .cell-2 img {
        width: 100%;
    }

    .cell-8 img {
        width: 100%;
    }

    .logo {
        border-radius: 100%;
    }

    /*Phone */

    @media screen and (max-width: 767px) {
        .section-instagram {
            /*4x2 Grid, with 4 images*/
            justify-content: center;
            align-items: stretch;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: repeat(2, 1fr);
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .cell-2 {
            grid-area: 1 / 1 / 3 / 3;
        }

        .cell-3 {
            grid-area: 1 / 3 / 2 / 4;
        }

        .cell-4 {
            grid-area: 1 / 4 / 2 / 5;
        }

        .cell-14 {
            grid-area: 2 / 3 / 3 / 5;
        }
    }

    /*Tablet, tabletLandscape, Desktop*/
    @media screen and (min-width: 768px) {
        .section-instagram {
            align-items: stretch;
            justify-content: center;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-template-rows: repeat(4, 1fr);
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .cell-1 {
            grid-area: 1 / 1 / 3 / 3;
        }

        .cell-2 {
            grid-area: 1 / 3 / 2 / 4;
        }

        .cell-3 {
            grid-area: 1 / 4 / 2 / 5;
        }

        .cell-4 {
            grid-area: 1 / 5 / 2 / 6;
        }

        .cell-5 {
            grid-area: 2 / 3 / 3 / 4;
        }

        .cell-6 {
            grid-area: 2 / 4 / 3 / 5;
        }

        .cell-7 {
            grid-area: 2 / 5 / 3 / 6;
        }

        .cell-8 {
            grid-area: 3 / 1 / 5 / 3;
        }

        .cell-9 {
            grid-area: 3 / 3 / 4 / 4;
        }

        .cell-10 {
            grid-area: 3 / 4 / 4 / 5;
        }

        .cell-11 {
            grid-area: 3 / 5 / 4 / 6;
        }

        .cell-12 {
            grid-area: 4 / 3 / 5 / 4;
        }

        .cell-13 {
            grid-area: 4 / 4 / 5 / 5;
        }

        .cell-14 {
            grid-area: 4 / 5 / 5 / 6;
        }
    }

    @media screen and (min-width: 1024px) {
        .section-instagram {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-template-rows: repeat(4, 1fr);
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }
    }

    @media screen and (min-width: 1280px) {
        .section-instagram {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-template-rows: repeat(4, 1fr);
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .cel-1 {
            grid-area: 1 / 1 / 3 / 3;
        }

        .cel-2 {
            grid-area: 1 / 3 / 2 / 4;
        }

        .cel-3 {
            grid-area: 1 / 4 / 2 / 5;
        }

        .cel-4 {
            grid-area: 1 / 5 / 2 / 6;
        }

        .cel-5 {
            grid-area: 2 / 3 / 3 / 4;
        }

        .cel-6 {
            grid-area: 2 / 4 / 3 / 5;
        }

        .cel-7 {
            grid-area: 2 / 5 / 3 / 6;
        }

        .cel-8 {
            grid-area: 3 / 1 / 5 / 3;
        }

        .cel-9 {
            grid-area: 3 / 3 / 4 / 4;
        }

        .cel-10 {
            grid-area: 3 / 4 / 4 / 5;
        }

        .cel-11 {
            grid-area: 3 / 5 / 4 / 6;
        }

        .cel-12 {
            grid-area: 4 / 3 / 5 / 4;
        }

        .cel-13 {
            grid-area: 4 / 4 / 5 / 5;
        }

        .cel-14 {
            grid-area: 4 / 5 / 5 / 6;
        }
    }

    /* HD 1920*/
    @media screen and (min-width: 1920px) {
        .section-instagram {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            grid-template-rows: repeat(3, 1fr);
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .cell-1 {
            grid-area: 1 / 1 / 3 / 3;
        }

        .cell-2 {
            grid-area: 1 / 3 / 2 / 4;
        }

        .cell-3 {
            grid-area: 1 / 4 / 2 / 5;
        }

        .cell-4 {
            grid-area: 1 / 5 / 2 / 6;
        }

        .cell-5 {
            grid-area: 2 / 3 / 3 / 4;
        }

        .cell-6 {
            grid-area: 2 / 4 / 3 / 5;
        }

        .cell-7 {
            grid-area: 2 / 5 / 3 / 6;
        }

        .cell-8 {
            grid-area: 1 / 6 / 3 / 8;
        }

        .cell-9 {
            grid-area: 3 / 1 / 4 / 2;
        }

        .cell-10 {
            grid-area: 3 / 2 / 4 / 3;
        }

        .cell-11 {
            grid-area: 3 / 3 / 4 / 4;
        }

        .cell-12 {
            grid-area: 3 / 4 / 4 / 5;
        }

        .cell-13 {
            grid-area: 3 / 5 / 4 / 6;
        }

        .cell-14 {
            grid-area: 3 / 7 / 4 / 8;
        }

        .cell-15 {
            grid-area: 3 / 6 / 4 / 7;
        }
    }

    /*Imac 2560 */
    @media screen and (min-width: 2560px) {
        .section-instagram {
            display: grid;
            grid-template-columns: repeat(10, 254px);
            grid-template-rows: repeat(2, 254px);
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .cell-1 {
            grid-area: 1 / 1 / 3 / 3;
        }

        .cell-2 {
            grid-area: 1 / 3 / 2 / 4;
        }

        .cell-3 {
            grid-area: 1 / 4 / 2 / 5;
        }

        .cell-4 {
            grid-area: 1 / 5 / 2 / 6;
        }

        .cell-5 {
            grid-area: 2 / 3 / 3 / 4;
        }

        .cell-6 {
            grid-area: 2 / 4 / 3 / 5;
        }

        .cell-7 {
            grid-area: 2 / 5 / 3 / 6;
        }

        .cell-8 {
            grid-area: 1 / 6 / 3 / 8;
        }

        .cell-9 {
            grid-area: 1 / 8 / 2 / 9;
        }

        .cell-10 {
            grid-area: 1 / 9 / 2 / 10;
        }

        .cell-11 {
            grid-area: 1 / 10 / 2 / 11;
        }

        .cell-12 {
            grid-area: 2 / 8 / 3 / 9;
        }

        .cell-13 {
            grid-area: 2 / 9 / 3 / 10;
        }

        .cell-14 {
            grid-area: 2 / 10 / 3 / 11;
        }
    }
</style>
